import styled from 'styled-components';

import { Box, BoxProps } from '../../common/ui/Box';
import { theme } from '../../common/ui/theme';

interface CalloutWrapperProps
    extends Pick<BoxProps, 'backgroundColor' | 'borderColor' | 'borderWidth' | 'borderRadius'> {
    isWide: boolean;
}

export const CalloutWrapper = styled(Box)<CalloutWrapperProps>`
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: ${({ isWide }) => (isWide ? 'row' : 'column')};
    align-items: ${({ isWide }) => (isWide ? 'center' : 'flex-start')};
    justify-content: ${({ isWide }) => (isWide ? 'space-between' : 'flex-start')};
    row-gap: ${theme.space[8]};
    padding: ${theme.space[16]};
    border-style: solid;
`;
